

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"45","height":"45","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('ellipse', {"fill":"#FFF","cx":"22.5","cy":"22.468","rx":"22.5","ry":"22.468"}, []), h('g', {"fill":"#003E99","fill-rule":"nonzero"}, [h('path', {"d":"M32.964 16.87v2.098c0 2.827-2.238 5.12-5 5.12-2.761 0-5-2.293-5-5.12V16.87c0-2.828 2.239-5.12 5-5.12 2.762 0 5 2.292 5 5.12zM36.5 32.473h-17a.5.5 0 01-.461-.69c1.604-3.882 4.628-5.823 9.073-5.823 4.45 0 7.402 1.946 8.856 5.838a.5.5 0 01-.469.675zM13.877 17.21c.264 0 .478.214.478.478v3.828h3.811c.264 0 .478.214.478.478v1.915a.478.478 0 01-.478.478h-3.812v3.829a.478.478 0 01-.477.478h-1.904a.478.478 0 01-.478-.478v-3.83l-3.812.001a.478.478 0 01-.478-.478v-1.915c0-.264.214-.478.478-.478h3.811v-3.828c0-.264.215-.478.479-.478h1.904z"}, [])])])]);
};

        